import React from "react";

// Material UI
import {
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";

// Components
import { CardInfo } from "Common/Components";
import ReactMarkdown from "react-markdown";

// Fields
import { optionalSettingsFields } from "../Common/fields";

// Styles
import { textStyles, commonStyles } from "Common/Styles";

const OptionalSettingsPage = ({ formik, viewOnly = false }) => {
  return (
    <>
      <CardInfo
        title="Optional Settings"
        tooltipInfo="Customize the clinic's view with advanced configuration options."
      >
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table size="small">
            <TableBody>
              {optionalSettingsFields.map((v) => {
                return (
                  <TableRow key={v.id}>
                    <TableCell sx={textStyles.subtitle}>{v.label}</TableCell>
                    <TableCell sx={textStyles.infoText}>
                      <ReactMarkdown
                        components={{
                          p: ({ node, ...props }) => <span {...props} />, // Remove <p> tag for inline
                        }}
                      >
                        {v.description}
                      </ReactMarkdown>
                    </TableCell>
                    <TableCell>
                      <Switch
                        name={`settings.${v.id}`}
                        id={`settings.${v.id}`}
                        disabled={viewOnly}
                        checked={formik.values.settings?.[v.id]}
                        onChange={() => {
                          formik.setFieldValue(
                            `settings.${v.id}`,
                            !formik.values.settings?.[v.id]
                          );
                        }}
                        sx={commonStyles.terracottaSwitch}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardInfo>
    </>
  );
};

export default OptionalSettingsPage;
